// src/components/eventos/views/EventosCadastro.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import EventoForm from '../components/EventoForm';
import EventosList from '../components/EventosList';

/* ---- Ícones SVG ---- */
const ArrowLeftIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="15 18 9 12 15 6" />
    </svg>
);
const EditIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
);
const ListIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="8" y1="6" x2="21" y2="6" /><line x1="8" y1="12" x2="21" y2="12" /><line x1="8" y1="18" x2="21" y2="18" />
        <line x1="3" y1="6" x2="3.01" y2="6" /><line x1="3" y1="12" x2="3.01" y2="12" /><line x1="3" y1="18" x2="3.01" y2="18" />
    </svg>
);
const PlusIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" />
    </svg>
);
const LogoutIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><polyline points="16 17 21 12 16 7" /><line x1="21" y1="12" x2="9" y2="12" />
    </svg>
);
const ChevronIcon = () => (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const EventosCadastro = ({ supabase, session, clienteData, onLogout }) => {
    const navigate = useNavigate();
    const toast = useToast();
    const [visualizacao, setVisualizacao] = useState('lista');
    const [eventoEditando, setEventoEditando] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);

    const nomeUsuario = session?.user?.user_metadata?.nome || 'Usuário';
    const iniciais = nomeUsuario.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();

    const handleLogout = async () => {
        try { await onLogout(); } catch (e) { console.error(e); }
    };

    const handleNovoEvento = () => { setEventoEditando(null); setVisualizacao('novo'); };
    const handleEditarEvento = (e) => { setEventoEditando(e); setVisualizacao('editar'); };
    const handleVoltarLista = () => { setEventoEditando(null); setVisualizacao('lista'); };
    const handleEventoSalvo = () => {
        toast({ title: eventoEditando ? 'Evento atualizado' : 'Evento criado', status: 'success', duration: 3000, isClosable: true });
        handleVoltarLista();
    };

    React.useEffect(() => {
        if (!menuOpen) return;
        const close = () => setMenuOpen(false);
        document.addEventListener('click', close);
        return () => document.removeEventListener('click', close);
    }, [menuOpen]);

    const isLista = visualizacao === 'lista';

    return (
        <>
            <style>{`
                .ec-tab-btn { display:inline-flex; align-items:center; gap:8px; padding:9px 18px; border-radius:10px; font-size:13px; font-weight:600; border:1px solid transparent; cursor:pointer; font-family:inherit; transition:all 0.2s; }
                .ec-tab-btn.active { background:rgba(44,203,144,0.1); border-color:rgba(44,203,144,0.25); color:#2CCB90; }
                .ec-tab-btn.inactive { background:#f8fafc; border-color:#e2e8f0; color:#64748b; }
                .ec-tab-btn.inactive:hover { background:#f0fdf8; color:#1e293b; }

                .ec-menu-item { display:flex; align-items:center; gap:10px; width:100%; padding:10px 14px; border-radius:10px; font-size:13px; font-weight:500; color:#64748b; background:none; border:none; cursor:pointer; font-family:inherit; transition:all 0.15s; text-align:left; }
                .ec-menu-item:hover { background:#f8fafc; color:#1e293b; }
                .ec-menu-item.danger { color:#ef4444; }
                .ec-menu-item.danger:hover { background:rgba(239,68,68,0.06); }

                @media (max-width: 640px) { .ec-nav-email { display:none; } }
            `}</style>

            <div style={{ minHeight:'100vh', background:'#f0faf6', fontFamily:"'Inter', -apple-system, sans-serif" }}>

                {/* NAVBAR */}
                <header style={{ position:'sticky', top:0, zIndex:50, background:'rgba(255,255,255,0.9)', backdropFilter:'blur(24px)', WebkitBackdropFilter:'blur(24px)', borderBottom:'1px solid #e2e8f0' }}>
                    <div style={{ maxWidth:'1280px', margin:'0 auto', padding:'0 24px', height:'64px', display:'flex', alignItems:'center', justifyContent:'space-between', gap:'16px' }}>
                        <div style={{ display:'flex', alignItems:'center', gap:'14px' }}>
                            <div style={{ display:'inline-flex', alignItems:'center', background:'#ffffff', borderRadius:'10px', padding:'6px 14px', boxShadow:'0 2px 8px rgba(0,0,0,0.08)', border:'1px solid #e2e8f0' }}>
                                <img src="/logo-horizontal.png" alt="Evlo" style={{ height:'26px', objectFit:'contain' }} onError={e => { e.target.style.display='none'; }} />
                            </div>
                            <button onClick={() => navigate('/eventos')} style={{ display:'flex', alignItems:'center', gap:'6px', padding:'7px 14px', borderRadius:'10px', background:'#f8fafc', border:'1px solid #e2e8f0', color:'#64748b', fontSize:'13px', fontWeight:500, cursor:'pointer', fontFamily:'inherit', transition:'all 0.15s', whiteSpace:'nowrap' }}
                                onMouseEnter={e => e.currentTarget.style.background='#f0fdf8'}
                                onMouseLeave={e => e.currentTarget.style.background='#f8fafc'}
                            >
                                <ArrowLeftIcon /> Voltar aos Eventos
                            </button>
                            {clienteData && (
                                <span style={{ padding:'4px 12px', borderRadius:'100px', background:'rgba(44,203,144,0.1)', border:'1px solid rgba(44,203,144,0.2)', color:'#2CCB90', fontSize:'11px', fontWeight:700 }}>
                                    {clienteData.nome}
                                </span>
                            )}
                        </div>

                        <div style={{ position:'relative' }}>
                            <button
                                onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
                                style={{ display:'flex', alignItems:'center', gap:'10px', padding:'6px 12px', borderRadius:'12px', background: menuOpen ? '#f8fafc' : '#ffffff', border:'1px solid #e2e8f0', cursor:'pointer', transition:'all 0.15s', fontFamily:'inherit' }}
                            >
                                <div style={{ width:'32px', height:'32px', borderRadius:'50%', background:'linear-gradient(135deg, #2CCB90, #2DB8E1)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'12px', fontWeight:700, color:'#fff', flexShrink:0 }}>
                                    {iniciais}
                                </div>
                                <div className="ec-nav-email" style={{ textAlign:'left' }}>
                                    <p style={{ margin:0, fontSize:'13px', fontWeight:600, color:'#0f172a' }}>{nomeUsuario}</p>
                                </div>
                                <span style={{ color:'#94a3b8', transition:'transform 0.2s', transform: menuOpen ? 'rotate(180deg)' : 'none' }}><ChevronIcon /></span>
                            </button>

                            {menuOpen && (
                                <div style={{ position:'absolute', top:'calc(100% + 8px)', right:0, minWidth:'190px', background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:'14px', boxShadow:'0 16px 48px rgba(0,0,0,0.12)', padding:'8px', zIndex:100 }}>
                                    <button className="ec-menu-item" onClick={() => { navigate('/perfil'); setMenuOpen(false); }}>Meu Perfil</button>
                                    <div style={{ height:'1px', background:'#e2e8f0', margin:'6px 0' }} />
                                    <button className="ec-menu-item danger" onClick={handleLogout}><LogoutIcon /> Sair</button>
                                </div>
                            )}
                        </div>
                    </div>
                </header>

                {/* CONTEÚDO */}
                <main style={{ position:'relative', zIndex:1, maxWidth:'1280px', margin:'0 auto', padding:'32px 24px 80px' }}>

                    {/* Header */}
                    <div style={{ display:'flex', alignItems:'center', gap:'12px', marginBottom:'8px' }}>
                        <div style={{ width:'40px', height:'40px', borderRadius:'12px', background:'linear-gradient(135deg, rgba(44,203,144,0.15), rgba(45,184,225,0.15))', border:'1px solid rgba(44,203,144,0.2)', display:'flex', alignItems:'center', justifyContent:'center', color:'#2CCB90' }}>
                            <EditIcon />
                        </div>
                        <div>
                            <h1 style={{ margin:0, fontSize:'clamp(20px,3vw,28px)', fontWeight:800, color:'#0f172a', letterSpacing:'-0.02em' }}>Cadastro de Eventos</h1>
                            <p style={{ margin:0, fontSize:'13px', color:'#64748b' }}>
                                {isLista ? 'Gerencie todos os seus eventos' : visualizacao === 'novo' ? 'Crie um novo evento' : 'Edite o evento'}
                            </p>
                        </div>
                    </div>

                    {/* Tabs */}
                    <div style={{ display:'flex', gap:'8px', marginBottom:'24px', marginTop:'20px' }}>
                        <button className={`ec-tab-btn ${isLista ? 'active' : 'inactive'}`} onClick={handleVoltarLista}>
                            <ListIcon /> Ver Todos
                        </button>
                        <button className={`ec-tab-btn ${!isLista ? 'active' : 'inactive'}`} onClick={handleNovoEvento}>
                            <PlusIcon /> Novo Evento
                        </button>
                    </div>

                    {/* Conteúdo dinâmico */}
                    <div style={{ background:'#ffffff', border:'1px solid #e2e8f0', borderRadius:'16px', boxShadow:'0 1px 4px rgba(0,0,0,0.06)' }}>
                        {isLista ? (
                            <EventosList
                                supabase={supabase}
                                session={session}
                                onEditarEvento={handleEditarEvento}
                                onNovoEvento={handleNovoEvento}
                            />
                        ) : (
                            <EventoForm
                                supabase={supabase}
                                session={session}
                                eventoEditando={eventoEditando}
                                onEventoSalvo={handleEventoSalvo}
                                onCancelar={handleVoltarLista}
                            />
                        )}
                    </div>
                </main>
            </div>
        </>
    );
};

export default EventosCadastro;
